<template>
  <div class="h-100">

  <div v-if="type === 'burger'" class="m-0 p-0">
    <div v-show="false">
      <router-link class="sub_list_item" :id="'/p2p/offers'" :to="'/p2p/offers'"></router-link>
      <router-link class="sub_list_item" :id="'/keyts/list'" :to="'/keyts/list'"></router-link>
    </div>
  </div>

  <div v-if="type === 'base'" class="menu_item" :class="{ active: open }" @click="toggle" ref="menu_item">
    <div class="menu_title_row" :class="{ active: open }">
      <Icon v-if="menuIcon" :name="menuIcon" size="c20" />
      <span class="neue fsp16 lh24">{{ headerTitle }}</span>
    </div>
    <Transition name="card-fade">
      <div class="card-dropdown card-dropdown--center" v-show="open" @click.stop>
        <div class="card-columns">
          <div class="card-column">
            <component
              v-for="(menu_item, index) in leftColumnItems"
              :key="'l-' + index"
              :is="menu_item.func ? 'div' : 'router-link'"
              :to="menu_item.func ? undefined : getTo(menu_item)"
              class="card-box"
              @click="handleCardItemClick(menu_item)"
            >
              <Icon :name="menu_item.icon" size="c20" class="card-box__icon" />
              <div class="card-box__text">
                <span class="card-box__title neue fsp16 lh24">{{ getTranslation(menu_item.subtitle) }}</span>
                <span v-if="menu_item.description" class="card-box__desc neue-roman fsp14 lh20">{{ getTranslation(menu_item.description) }}</span>
              </div>
            </component>
          </div>
          <div class="card-column" v-if="rightColumnItems.length">
            <component
              v-for="(menu_item, index) in rightColumnItems"
              :key="'r-' + index"
              :is="menu_item.func ? 'div' : 'router-link'"
              :to="menu_item.func ? undefined : getTo(menu_item)"
              class="card-box"
              @click="handleCardItemClick(menu_item)"
            >
              <Icon :name="menu_item.icon" size="c20" class="card-box__icon" />
              <div class="card-box__text">
                <span class="card-box__title neue fsp16 lh24">{{ getTranslation(menu_item.subtitle) }}</span>
                <span v-if="menu_item.description" class="card-box__desc neue-roman fsp14 lh20">{{ getTranslation(menu_item.description) }}</span>
              </div>
            </component>
          </div>
        </div>
      </div>
    </Transition>
  </div>

  <div
    v-else-if="(type === 'burger' || type === 'admin-menu') && item.length && !this.mobile"
    class="burger_menu_item"
    :class="{ active: this.open }"
    v-on:click="this.toggle"
    id="burger"
    ref="burger_item"
  >
    <Icon :name="type === 'burger' ? 'menu' : 'user-round-cog'" size="c24" class="burger_icon" />

    <Transition name="card-fade">
      <div class="card-dropdown card-dropdown--right" v-show="open" @click.stop>
        <!-- Overflow main items: accordion -->
        <div v-if="burgerMainItems.length" class="mob-menu-section">
          <div v-for="(section, sKey) in burgerMainItems" :key="'bm-' + sKey" class="mob-menu-group">
            <div
              class="mob-menu-item"
              :class="{ 'mob-menu-item--open': mobileExpandedIndex === sKey }"
              @click="toggleMobileSection(sKey)"
            >
              <Icon v-if="section.icon" :name="section.icon" :active="false" size="c20" class="card-box__icon" />
              <span class="mob-menu-item__title neue fsp16 lh24">{{ getTranslation(section.title) }}</span>
              <Icon name="chevron-down" size="c20" class="mob-menu-item__chevron" :class="{ 'mob-menu-item__chevron--open': mobileExpandedIndex === sKey }" />
            </div>
            <div v-show="mobileExpandedIndex === sKey" class="mob-menu-subitems">
              <component
                v-for="(menu_item, index) in section.groups"
                :key="'bms-' + sKey + '-' + index"
                :is="menu_item.func ? 'div' : 'router-link'"
                :to="menu_item.func ? undefined : getTo(menu_item)"
                class="mob-menu-subitem neue fsp16 lh24"
                @click="handleCardItemClick(menu_item)"
              >
                {{ getTranslation(menu_item.subtitle) }}
              </component>
            </div>
          </div>
        </div>

        <!-- Separator -->
        <div v-if="burgerMainItems.length && burgerExtraItems.length" class="mob-menu-separator"></div>

        <!-- Original burger items: flat -->
        <template v-for="(burger, bKey) in burgerExtraItems" :key="'be-' + bKey">
          <component
            v-for="(menu_item, index) in burger.groups"
            :key="'bei-' + bKey + '-' + index"
            :is="menu_item.func ? 'div' : 'router-link'"
            :to="menu_item.func ? undefined : getTo(menu_item)"
            class="card-box"
            @click="handleCardItemClick(menu_item)"
          >
            <Icon :name="menu_item.icon" :active="false" size="c20" class="card-box__icon" />
            <div class="card-box__text">
              <span class="card-box__title neue fsp16 lh24">{{ getTranslation(menu_item.subtitle) }}</span>
            </div>
          </component>
        </template>
      </div>
    </Transition>
  </div>

  <!-- Mobile burger menu -->
  <div
    v-else-if="(type === 'burger' || type === 'admin-menu') && item.length && this.mobile"
    class="burger_menu_item"
    :class="{ active: this.open }"
    v-on:click="this.toggle"
    id="burger"
    ref="burger_item"
  >
    <Icon :name="type === 'burger' ? 'menu' : 'user-round-cog'" size="c24" class="burger_icon" />

    <Transition name="card-fade">
      <div class="card-dropdown card-dropdown--mobile" v-show="open" @click.stop>

        <!-- Main sections (expandable) -->
        <div v-if="burgerMainItems.length" class="mob-menu-section">
          <div v-for="(section, sKey) in burgerMainItems" :key="'m-' + sKey" class="mob-menu-group">
            <div
              class="mob-menu-item"
              :class="{ 'mob-menu-item--open': mobileExpandedIndex === sKey }"
              @click="toggleMobileSection(sKey)"
            >
              <Icon :name="section.icon" size="c20" class="card-box__icon" />
              <span class="mob-menu-item__title neue fsp16 lh24">{{ getTranslation(section.title) }}</span>
              <Icon name="chevron-down" size="c20" class="mob-menu-item__chevron" :class="{ 'mob-menu-item__chevron--open': mobileExpandedIndex === sKey }" />
            </div>
            <div v-show="mobileExpandedIndex === sKey" class="mob-menu-subitems">
              <component
                v-for="(sub, subIdx) in section.groups"
                :key="'ms-' + subIdx"
                :is="sub.func ? 'div' : 'router-link'"
                :to="sub.func ? undefined : getTo(sub)"
                class="mob-menu-subitem neue fsp16 lh24"
                @click="handleCardItemClick(sub)"
              >
                {{ getTranslation(sub.subtitle) }}
              </component>
            </div>
          </div>
        </div>

        <!-- Separator between main and burger -->
        <div v-if="burgerMainItems.length && burgerExtraItems.length" class="mob-menu-separator"></div>

        <!-- Burger items (flat) -->
        <template v-for="(section, bKey) in burgerExtraItems" :key="'b-' + bKey">
          <div v-if="bKey > 0" class="mob-menu-separator"></div>
          <div class="mob-menu-section">
            <component
              v-for="(menu_item, index) in section.groups"
              :key="'bi-' + bKey + '-' + index"
              :is="menu_item.func ? 'div' : 'router-link'"
              :to="menu_item.func ? undefined : getTo(menu_item)"
              class="mob-menu-item"
              @click="handleCardItemClick(menu_item)"
            >
              <Icon :name="menu_item.icon" :active="false" size="c20" class="card-box__icon" />
              <span class="mob-menu-item__title neue fsp16 lh24">{{ getTranslation(menu_item.subtitle) }}</span>
            </component>
          </div>
        </template>

      </div>
    </Transition>
  </div>


  <!-- Desktop user menu -->
  <div
    v-else-if="type === 'user' && !this.mobile"
    class="user_menu_item"
    :class="{ active: this.open }"
    @click="this.handleUserMenuClick"
    ref="user_item"
  >
    <img
      v-if="this.$store.state.userData.avatar"
      class="user_img"
      :src="this.$store.state.userData.avatar"
    />
    <img v-else class="user_img" :src="$store.state.individual === 'Zentrolink' ? require('@/assets/avatar-default-company.svg') : require('@/assets/avatar-default-header.svg')" />
    <Transition name="card-fade">
      <div class="card-dropdown card-dropdown--right card-dropdown--user" v-show="open" @click.stop>
        <!-- User info header -->
        <div class="card-user-header">
          <img v-if="this.$store.state.userData.avatar" class="card-user-avatar" :src="this.$store.state.userData.avatar" />
          <img v-else class="card-user-avatar" src="@/assets/avatar-default-card.svg" />
          <div class="card-user-info">
            <span class="card-user-name neue fsp16 lh24">{{ this.$store.getters.get_user_name }}</span>
            <template v-if="this.idents.length > 0">
              <span
                v-for="row in this.idents"
                :key="row.code"
                class="card-user-id neue-roman fsp14 lh20 pointer"
                @click="copy(row.ident)"
              >
                {{ $t('components.service.topmenu.1') }} {{ this.$lib.getTokenString(row.ident, 4) }}
                <Icon name="copy" size="c16" />
              </span>
            </template>
            <span v-else class="card-user-id neue-roman fsp14 lh20 pointer" @click="copy(this.$store.state.userData.id)">
              ID: {{ this.$lib.getTokenString(this.$store.state.userData.id, 4) }}
              <Icon name="copy" size="c16" />
            </span>
          </div>
        </div>

        <!-- Menu items -->
        <template v-for="(burger, key) in item" :key="key">
          <component
            v-for="(menu_item, index) in burger.groups"
            :key="key + '-' + index"
            :is="menu_item.func ? 'div' : 'router-link'"
            :to="menu_item.func ? undefined : getTo(menu_item)"
            class="card-box"
            @click="handleCardItemClick(menu_item)"
          >
            <Icon :name="menu_item.icon" size="c20" class="card-box__icon" />
            <div class="card-box__text">
              <span class="card-box__title neue fsp16 lh24">{{ getTranslation(menu_item.subtitle) }}</span>
            </div>
          </component>
        </template>

        <!-- Language -->
        <div class="card-lang-box" :class="{ 'card-lang-box--open': langOpen }" @click.stop="langOpen = !langOpen">
          <div class="card-lang-box__header">
            <Icon name="lng" size="c20" class="card-box__icon" />
            <span class="card-box__title neue fsp16 lh24">{{ $t('components.service.topmenu.2') }}</span>
          </div>
          <div v-show="langOpen" class="card-lang-dropdown" @click.stop>
            <div class="card-lang-dropdown__select" @click="langListOpen = !langListOpen">
              <span class="neue fsp14 lh20">{{ currentLangName }}</span>
              <Icon name="chevron-down" size="c16" :class="{ 'card-lang-dropdown__chevron--open': langListOpen }" class="card-lang-dropdown__chevron" />
            </div>
            <div v-show="langListOpen" class="card-lang-list">
              <div
                v-for="(l, idx) in availableLangs"
                :key="idx"
                class="card-lang-list__item neue fsp14 lh20"
                :class="{ 'card-lang-list__item--active': l.shortName === currentLangCode }"
                @click="selectLang(l)"
              >
                {{ l.localName }}
              </div>
            </div>
          </div>
        </div>

        <!-- Logout -->
        <div class="card-box card-box--logout" @click="logout">
          <Icon name="logout" size="c20" class="card-box__icon card-box__icon--logout" />
          <div class="card-box__text">
            <span class="card-box__title card-box__title--logout neue fsp16 lh24">{{ $t('components.service.topmenu.7') }}</span>
          </div>
        </div>
      </div>
    </Transition>
  </div>

  <!-- Mobile user menu -->
  <div
    v-else-if="type === 'user' && this.mobile"
    class="user_menu_item"
    :class="{ active: this.open }"
    @click="this.handleUserMenuClick"
    ref="user_item"
  >
    <img
      v-if="this.$store.state.userData.avatar"
      class="user_img"
      :src="this.$store.state.userData.avatar"
    />
    <img v-else class="user_img" :src="$store.state.individual === 'Zentrolink' ? require('@/assets/avatar-default-company.svg') : require('@/assets/avatar-default-header.svg')" />
    <Transition name="card-fade">
      <div class="card-dropdown card-dropdown--mobile card-dropdown--user" v-show="open" @click.stop>
        <!-- User info header -->
        <div class="card-user-header">
          <img v-if="this.$store.state.userData.avatar" class="card-user-avatar" :src="this.$store.state.userData.avatar" />
          <img v-else class="card-user-avatar" src="@/assets/avatar-default-card.svg" />
          <div class="card-user-info">
            <span class="card-user-name neue fsp16 lh24">{{ this.$store.getters.get_user_name }}</span>
            <template v-if="this.idents.length > 0">
              <span
                v-for="row in this.idents"
                :key="row.code"
                class="card-user-id neue-roman fsp14 lh20 pointer"
                @click="copy(row.ident)"
              >
                {{ $t('components.service.topmenu.1') }} {{ this.$lib.getTokenString(row.ident, 4) }}
                <Icon name="copy" size="c16" />
              </span>
            </template>
            <span v-else class="card-user-id neue-roman fsp14 lh20 pointer" @click="copy(this.$store.state.userData.id)">
              ID: {{ this.$lib.getTokenString(this.$store.state.userData.id, 4) }}
              <Icon name="copy" size="c16" />
            </span>
          </div>
        </div>

        <!-- Menu items -->
        <template v-for="(burger, key) in item" :key="key">
          <component
            v-for="(menu_item, index) in burger.groups"
            :key="key + '-' + index"
            :is="menu_item.func ? 'div' : 'router-link'"
            :to="menu_item.func ? undefined : getTo(menu_item)"
            class="card-box"
            @click="handleCardItemClick(menu_item)"
          >
            <Icon :name="menu_item.icon" size="c20" class="card-box__icon" />
            <div class="card-box__text">
              <span class="card-box__title neue fsp16 lh24">{{ getTranslation(menu_item.subtitle) }}</span>
            </div>
          </component>
        </template>

        <!-- Language -->
        <div class="card-lang-box" :class="{ 'card-lang-box--open': langOpen }" @click.stop="langOpen = !langOpen">
          <div class="card-lang-box__header">
            <Icon name="lng" size="c20" class="card-box__icon" />
            <span class="card-box__title neue fsp16 lh24">{{ $t('components.service.topmenu.2') }}</span>
          </div>
          <div v-show="langOpen" class="card-lang-dropdown" @click.stop>
            <div class="card-lang-dropdown__select" @click="langListOpen = !langListOpen">
              <span class="neue fsp14 lh20">{{ currentLangName }}</span>
              <Icon name="chevron-down" size="c16" :class="{ 'card-lang-dropdown__chevron--open': langListOpen }" class="card-lang-dropdown__chevron" />
            </div>
            <div v-show="langListOpen" class="card-lang-list">
              <div
                v-for="(l, idx) in availableLangs"
                :key="idx"
                class="card-lang-list__item neue fsp14 lh20"
                :class="{ 'card-lang-list__item--active': l.shortName === currentLangCode }"
                @click="selectLang(l)"
              >
                {{ l.localName }}
              </div>
            </div>
          </div>
        </div>

        <!-- Logout -->
        <div class="card-box card-box--logout" @click="logout">
          <Icon name="logout" size="c20" class="card-box__icon card-box__icon--logout" />
          <div class="card-box__text">
            <span class="card-box__title card-box__title--logout neue fsp16 lh24">{{ $t('components.service.topmenu.7') }}</span>
          </div>
        </div>
      </div>
    </Transition>
  </div>
  </div>
</template>

<script>
import Icon from "@/components/icons/Icon.vue";

export default {
  components: {
    Icon,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      default: "base",
    },
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lang: this.$i18n.locale,
      langDefault: process.env.VUE_APP_I18N_LOCALE,
      idents: this.$store.state.userData.ident,
      open: false,
      langOpen: false,
      langListOpen: false,
      mobileExpandedIndex: null,
    };
  },

  computed: {
    menuIcon() {
      if (this.type === 'base' && this.item.icon) {
        return this.item.icon;
      }
      return null;
    },
    headerTitle() {
      return this.getTranslation(this.item.title);
    },
    leftColumnItems() {
      if (this.type !== 'base' || !this.item.groups) return [];
      return this.item.groups.slice(0, 3);
    },
    rightColumnItems() {
      if (this.type !== 'base' || !this.item.groups) return [];
      return this.item.groups.slice(3);
    },
    burgerMainItems() {
      if (!Array.isArray(this.item)) return [];
      return this.item.filter(i => i.main);
    },
    burgerExtraItems() {
      if (!Array.isArray(this.item)) return [];
      return this.item.filter(i => !i.main);
    },
    availableLangs() {
      const defaultLangs = [
        { shortName: 'en', localName: 'English' },
        { shortName: 'ru', localName: 'Русский' },
        { shortName: 'de', localName: 'Deutsch' },
        { shortName: 'fr', localName: 'Français' },
        { shortName: 'cs', localName: 'Český' },
        { shortName: 'kk', localName: 'Қазақша' },
        { shortName: 'pl', localName: 'Polski' },
        { shortName: 'zh', localName: '中文' },
      ];
      const configLangs = this.$store.state.config.LOCALES;
      return configLangs && configLangs.length > 0 ? configLangs : defaultLangs;
    },
    currentLangCode() {
      return this.$i18n.locale;
    },
    currentLangName() {
      const found = this.availableLangs.find(l => l.shortName === this.currentLangCode);
      return found ? found.localName : this.currentLangCode;
    },
  },
  methods: {
    toggle() {
      this.open = !this.open;
      this.resetSubMenu();
      this.updateEventListeners();
    },

    toggleMobileSection(index) {
      this.mobileExpandedIndex = this.mobileExpandedIndex === index ? null : index;
    },
    selectLang(lang) {
      this.$i18n.locale = lang.shortName;
      localStorage.setItem('lang', lang.shortName);
      this.langOpen = false;
      this.$store.dispatch('reRender');
    },
    resetSubMenu() {
      this.langOpen = false;
      this.langListOpen = false;
      this.mobileExpandedIndex = null;
    },
    handleCardItemClick(menu_item) {
      if (menu_item.func) {
        menu_item.func();
      }
      this.toggle();
    },
    handleUserMenuClick(event) {
      if (!event.target.closest(".pointer.pe-auto")) {
        this.toggle();
      }
    },
    getTo(item) {
      if (item.domain) {
        return this.$store.state.domains[item.to] ? this.$store.state.domains[item.to] : item.to;
      }
      return item.to
    },
    copy(text) {
      this.$lib.copyTextS(text, this.$store)
    },
    updateEventListeners() {
      if (this.open) {
        document.addEventListener("click", this.handleClickOutside);
        document.addEventListener("touchstart", this.handleClickOutside);
      } else {
        document.removeEventListener("click", this.handleClickOutside);
        document.removeEventListener("touchstart", this.handleClickOutside);
      }
    },
    handleClickOutside(event) {
      const refs = [this.$refs.menu_item, this.$refs.burger_item, this.$refs.user_item];
      const isClickInside = refs.some((ref) => ref && ref.contains(event.target));

      if (event.target.closest(".pointer.pe-auto")) {
        return;
      }

      if (!isClickInside) {
        this.toggle();
      }
    },
    logout() {
      this.axios.post("logout", {no_loader: true}).then((res) => {
        this.$store.commit("USER_DATA", false);
        this.$router.push("/login");
      });
    },
    openAMLCheck() {
      this.toggle(); // Закрываем burger меню
      this.$store.commit('SIDE_PANEL_SHOW', {
        title: '',
        content: {
          component: 'AMLCheck',
          props: {}
        }
      });
    },
    getTranslation(text) {
      return text[this.lang] ? text[this.lang] : text[this.langDefault];
    },

  },
};
</script>

<style lang="scss" scoped>
$menu-item-width: 130px;
$menu-item-height: 100%;
$menu-padding: 20px;
$menu-gap: 20px;
$menu-border-radius: 10px;
$user-img-size: 40px;
$user-img-sm-size: 24px;
$user-img-big-size: 90px;

@mixin flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

@mixin hover-active {
  &:hover,
  &.active {
    background-color: $menu-bg-active;
    color: $menu-active;
  }
  &.active_wb {
    color: $menu-active;
  }
}

%menu-item-base {
  user-select: none;
  position: relative;
  cursor: pointer;
  @include flex-center;
  height: $menu-item-height;
  color: $menu-base;
}

%container-base {
  position: absolute;
  display: flex;
  cursor: default;
  top: 100%;
  overflow: hidden;
  border-bottom-right-radius: $menu-border-radius;
  border-bottom-left-radius: $menu-border-radius;
  border: 1px solid $menu-border;
}

%list-item-base {
  padding: 0 $menu-padding;
  height: 60px;
  display: flex;
  justify-content: space-between;
  gap: $menu-gap;
  align-items: center;
  color: $menu-base;
  cursor: pointer;
  @include hover-active;
}

.menu_item {
  @extend %menu-item-base;
  opacity: 0.6;
  transition: opacity 0.2s ease;

  &:hover,
  &.active {
    opacity: 1;
  }
}

.burger_menu_item,
.user_menu_item {
  @extend %menu-item-base;
}

.burger_icon {
  opacity: 0.6;
  transition: opacity 0.2s ease;

  :deep(.base_fill),
  :deep(.active_fill) {
    fill: #fff;
  }
  :deep(.base_stroke),
  :deep(.active_stroke) {
    stroke: #fff;
  }
}

.burger_menu_item:hover .burger_icon,
.burger_menu_item.active .burger_icon {
  opacity: 1;
}

.menu_title_row {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;

  :deep(.base_fill),
  :deep(.active_fill) {
    fill: #fff;
  }
  :deep(.base_stroke),
  :deep(.active_stroke) {
    stroke: #fff;
  }
}


.burger_menu_title {
  @extend %list-item-base;
}

.burger_main_title {
  @extend %list-item-base;
  &:hover {
    background-color: $menu-bg;
  }
}


.user_info {
  display: flex;
  background: $menu-bg-dark;
  padding: 10px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid $menu-border;
}

.user_info_container {
  height: 112px;
  width: 280px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
}

.user_name {
  font-size: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.user_img {
  width: $user-img-size;
  height: $user-img-size;
  min-width: $user-img-size;
  min-height: $user-img-size;
  border-radius: 50%;
  object-fit: cover;
}

.user_img_big {
  width: $user-img-big-size;
  height: $user-img-big-size;
  min-width: $user-img-big-size;
  min-height: $user-img-big-size;
  border-radius: 50%;
  object-fit: cover;
}

.user_img_sm {
  width: $user-img-sm-size;
  height: $user-img-sm-size;
  min-width: $user-img-sm-size;
  min-height: $user-img-sm-size;
  border-radius: 50%;
}

.menu_list {
  background: $menu-bg2;
  z-index: 1;
  width: 300px;
}

.user_list {
  @extend .menu_list;
  border: 1px solid $menu-border;
  width: 400px;
}

.mobile_user_list {
  @extend .menu_list;
  border: 1px solid $menu-border;
  border-radius: 8px;
  margin: 0 8px 8px 8px;
  width: auto;
}

.mobile_user_list.u_mobile {
  border-radius: 0 0 8px 8px;
}

.mobile_sub_list {
  @extend .menu_list;
  border: 1px solid $menu-border;
  width: 100%;
  border-radius: 8px;
}

.menu_container {
  @extend %container-base;
  left: 0;
}

.burger_container {
  @extend %container-base;
  flex-direction: column;
  right: 0;
}
.scrolled_dropbar {
  max-height: 80vh;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
}
.mobile_burger_container {
  @extend %container-base;
  flex-direction: column;
  left: 0;
}

.list_item {
  @extend %list-item-base;
  border-top: $menu-border 1px solid;
  border-collapse: collapse;

  &:first-child {
    @media (min-width: 975px) {
      border-top: none;
    }
  }
}

.burger_list_item {
  border-bottom: $menu-border 1px solid;
  display: flex;
  flex-direction: column;

  &:last-child, &.active_li  {
      border-bottom: none;
  }

  &:first-child > .burger_menu_title  {
    border-radius: 8px 8px 0 0;
  }

  &:last-child > .burger_menu_title  {
    border-radius: 0 0 8px 8px;
  }

}

%sub-list-base {
  text-wrap: nowrap;
  overflow: hidden;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: start;
  gap: $menu-gap;

  > div > a {
    width: 100%;
    display: block;
  }
}

.sub_list {
  @extend %sub-list-base;
  background-color: $menu-bg-dark;
  padding: 20px;
}

.burger_sub_list {
  @extend %sub-list-base;
  background-color: $menu-bg-dark;
  padding: 20px;
}

.edit {
  position: absolute;
  @include flex-center;
  bottom: 0;
  right: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: $menu-border;
  outline: 1px solid #5d6a99;
}

.button {
  font-size: 15px;
  cursor: pointer;
  display: flex;
  padding: 5px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border: 1px solid $menu-border;
  background: $menu-bg;
  border-radius: 8px;
}

.id_container {
  display: flex;
  width: 100%;
  justify-content: end;
  gap: 10px;
}

.user_id {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 12px;
  font-size: 12px;
}

.sub_list_container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 100%;
  border-bottom: 1px solid $menu-border;
}

.sub_list_item {
  color: $menu-base;

  &:hover {
    color: $menu-active;
  }
}

.icon {
  transform: rotate(0deg);
  transition: all 0.2s ease-out;
}

.active_icon {
  transform: rotate(180deg);
}

.mobile_menu_list {
  position: fixed;
  top: var(--header-offset, 72px);
  left: 0;
  height: max-content;
  max-height: calc(90vh - var(--header-offset, 72px));
  background: $menu-bg;
  z-index: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
}

.mobile_menu_list::-webkit-scrollbar {
  width: 8px;
}

.mobile_menu_list::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}

.mobile_menu_list::-webkit-scrollbar-track {
  background: transparent;
}

.mobile_menu_container {
  padding: 15px 10px;
  background: $menu-bg2;
  border-radius: $menu-border-radius;
  border: 1px solid $menu-border;
  word-wrap: break-word;
  word-break: break-all;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
}

.mobile_list_item {
  display: flex;
  gap: 5px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  max-width: 120px;
  width: 100%;
  text-align: center;
}

.mobile_menu_title {
  font-size: 16px;
  font-weight: bold;
  color: $menu-active;
}

.mobile_menu_text {
  text-align: center;
  font-size: 15px;
  max-width: 120px;
  color: $menu-base;
}

.mobile_wrapp {
  position: fixed;
  z-index: 5;
  right: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
}

.mobile_close {
  position: absolute;
  border: 1px solid $menu-border;
  border-right: none;
  top: 40px;
  left: -40px;
  width: 40px;
  height: 40px;
  font-size: 20px;
  background: $menu-bg2;
  color: $menu-base;
  padding: 5px;
  border-radius: 40%;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;

  z-index: 9;
}

.mobile_sub_list {
  z-index: 10;
  position: fixed;
  padding: 50px 20px;
  right: 0;
  top: 0;
  width: 70vw;
  height: 100vh;
  background: $menu-bg2;
  border-radius: $menu-border-radius;
  border: 1px solid $menu-border;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* ─── Card Dropdown (new white card design) ─── */

.card-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  background: #fff;
  border-radius: 16px;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.15);
  padding: 12px;
  z-index: 100;
  cursor: default;
}

.card-dropdown--center {
  position: fixed;
  left: 50%;
  top: calc(var(--header-offset, 72px) + 8px);
  transform: translateX(-50%);
}

.card-dropdown--right {
  right: 0;
  min-width: 311px;
}

.card-dropdown--mobile {
  position: fixed;
  top: calc(var(--header-offset, 72px) + 8px);
  left: 12px;
  right: 12px;
  max-height: calc(90vh - var(--header-offset, 72px) - 8px);
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.15);
    border-radius: 2px;
  }
}

.card-dropdown--user {
  min-width: 311px;
}

/* Two-column layout for base type */
.card-columns {
  display: flex;
  gap: 16px;
}

.card-column {
  width: 278px;
  display: flex;
  flex-direction: column;
}

/* Single item box */
.card-box {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: $color-menu-active;
    text-decoration: none;
  }
}

.card-box__icon {
  flex-shrink: 0;
  margin-top: 2px;

  :deep(.base_fill),
  :deep(.active_fill) {
    fill: $menu-bg;
  }
  :deep(.base_stroke),
  :deep(.active_stroke) {
    stroke: $menu-bg;
  }
}

.card-box__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.card-box__title {
  color: $menu-bg;
  white-space: nowrap;
}

.card-box__desc {
  color: $primary-grey;
  white-space: normal;
}

.card-box--logout {
  &:hover {
    background-color: rgba($color-invalid, 0.08);
  }
}

.card-box__icon--logout {
  :deep(.base_fill),
  :deep(.active_fill) {
    fill: $color-invalid;
  }
  :deep(.base_stroke),
  :deep(.active_stroke) {
    stroke: $color-invalid;
  }
}

.card-box__title--logout {
  color: $color-invalid;
}

/* User card header */
.card-user-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  margin-bottom: 8px;
}

.card-user-avatar {
  width: 64px;
  height: 64px;
  min-width: 64px;
  min-height: 64px;
  border-radius: 50%;
  object-fit: cover;
}

.card-user-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.card-user-name {
  color: $menu-bg;
}

.card-user-id {
  color: $primary-grey;
  display: flex;
  align-items: center;
  gap: 4px;

  :deep(.base_fill),
  :deep(.active_fill) {
    fill: $primary-grey;
  }
  :deep(.base_stroke),
  :deep(.active_stroke) {
    stroke: $primary-grey;
  }
}

/* Language box */
.card-lang-box {
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;

  &:hover {
    background: $color-menu-active;
  }
}

.card-lang-box--open {
  background: $color-menu-active;
  cursor: default;
}

.card-lang-box__header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.card-lang-dropdown {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.card-lang-dropdown__select {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border: 1px solid $primary-stroke;
  border-radius: 8px;
  padding: 10px 12px;
  cursor: pointer;
  color: #000;
}

.card-lang-dropdown__chevron {
  transition: transform 0.15s ease;
}

.card-lang-dropdown__chevron--open {
  transform: rotate(180deg);
}

.card-lang-list {
  background: #fff;
  border: 1px solid $primary-stroke;
  border-radius: 8px;
  overflow-y: auto;
  max-height: 200px;
}

.card-lang-list__item {
  padding: 8px 12px;
  cursor: pointer;
  color: #000;

  &:hover {
    background: $color-menu-active;
  }
}

.card-lang-list__item--active {
  background: $color-menu-active;
  font-weight: 600;
}

/* Mobile menu */
.mob-menu-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mob-menu-group {
  display: flex;
  flex-direction: column;
}

.mob-menu-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    background: $color-menu-active;
  }
}

.mob-menu-item--open {
  background: $color-menu-active;
  border-radius: 8px 8px 0 0;
}

.mob-menu-item__title {
  flex: 1;
  color: $menu-bg;
}

.mob-menu-item__chevron {
  margin-left: auto;
  transition: transform 0.15s ease;

  :deep(.base_fill),
  :deep(.active_fill) {
    fill: $menu-bg;
  }
  :deep(.base_stroke),
  :deep(.active_stroke) {
    stroke: $menu-bg;
  }
}

.mob-menu-item__chevron--open {
  transform: rotate(180deg);
}

.mob-menu-subitems {
  display: flex;
  flex-direction: column;
  background: $color-menu-active;
  border-radius: 0 0 8px 8px;
  padding: 0 12px 12px;
}

.mob-menu-subitem {
  padding: 8px 0 8px 36px;
  color: $primary-grey;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: $menu-bg;
  }
}

.mob-menu-separator {
  height: 1px;
  background: $primary-stroke;
  margin: 8px 0;
}

/* Card fade transition */
.card-fade-enter-active,
.card-fade-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.card-fade-enter-from,
.card-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

.card-fade-enter-to,
.card-fade-leave-from {
  opacity: 1;
  transform: translateY(0);
}

/* Centered dropdowns: only fade opacity, no transform to avoid breaking fixed centering */
.card-dropdown--center {
  &.card-fade-enter-active,
  &.card-fade-leave-active {
    transition: opacity 0.15s ease;
  }

  &.card-fade-enter-from,
  &.card-fade-leave-to {
    opacity: 0;
    transform: translateX(-50%);
  }

  &.card-fade-enter-to,
  &.card-fade-leave-from {
    opacity: 1;
    transform: translateX(-50%);
  }
}
</style>
